<template>
  <div id="JewelleryPics">
    <div class="col-12 item-jewellery-pics text-center">
      <div v-for="(picture, itemIdx) in items[currentItem].description.jewelleryPics" :key="itemIdx">
        <img @click="showPicture(imageHost + '/conf2010/jewellery/' + picture)"
             :src="imageHost + '/conf2010/jewellery/' + picture" alt="Set"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImageJewelleryPics',
    data() {
      return {
        showPictureSrc: '',
        imageHost: process.env.VUE_APP_IMAGE_HOST
      };
    },
    props: [
      'items',
      'currentItem'
    ],
    mounted() {},
    methods: {
      showPicture: function(imgSrc) {
        this.$parent.showPicture(imgSrc);
      },
    },
    computed: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #JewelleryPics {
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 0;

    div.item-jewellery-pics {
      border-top: 0.2rem solid $darkGrey;
      display: flex;
      justify-content: center;
      padding: 0;
      margin: 0;

      div {
        display: flex;
        justify-content: center;

        img {
          width: max-content;
          max-width: 33.3%
        }
      }
    }
  }
</style>
